var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 43,
    viewBox: "0 0 90 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.381 1H1L0.999984 28.492H21.4444V41.8254H89V39.5397L86.6508 38.0159L86.3333 34.8413L84.0476 32.2381L84.1746 26.9682L83.6667 22.5238L81.8254 18.9682L81.5714 15.4762L78.9683 10.9682L78.7143 8.17458L76.3016 7.66665V6.14284L71.9841 4.49204L70.2698 3.15871L64.619 2.90474L62.3333 4.49204L57.381 1Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNe);
export default __webpack_public_path__ + "static/media/NE.08e9f810a1234fc047a4ea69369065b0.svg";
export { ForwardRef as ReactComponent };